import Client from "./clients/rest";

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */

export default {

    //#region Common services

    getApiRoutes() {
        return Client.get(`/system/membership/routes`);
    },

    getApiRulesSelect() {
        return Client.get(`/system/membership/rules-select`);
    },
    //#endregion  

    //#region Rules

    getRules() {
        return Client.get(`/system/membership/rules`);
    },

    getRule(id) {
        return Client.get(`/system/membership/rule`, {
            params: {
                id
            }
        });
    },

    putRule(form) {
        return Client.put(`/system/membership/rule`, form);
    },

    deleteRule(id) {
        return Client.delete(`/system/membership/rule`, {
            params: {
                id
            }
        });
    },
    //#endregion  

    //#region Rule Groups

    getRuleGroups() {
        return Client.get("/system/membership/rule-groups");
    },

    getRuleGroup(id) {
        return Client.get(`/system/membership/rule-group`, {
            params: {
                id
            }
        });
    },

    putRuleGroup(form) {
        return Client.put(`/system/membership/rule-group`, form);
    },

    deleteRuleGroup(id) {
        return Client.delete(`/system/membership/rule-group`, {
            params: {
                id
            }
        });
    },

    //#endregion

    //#region Member

    getSSOAdmin(term) {
        return Client.get(`/system/membership/admin-sso`, {
            params: {
                term
            }
        });
    },

    getMember(email) {
        return Client.get(`/system/membership/member`, {
            params: {
                email
            }
        });
    },

    putMember(form) {
        return Client.put(`/system/membership/member`, form);
    },

    deleteMember(memberId, ssoUserId) {
        return Client.delete(`/system/membership/member`, {
            params: {
                member_id: memberId,
                sso_user_id: ssoUserId
            }
        });
    },

    //#endregion 

    //#region Admin

    createAdmin(email) {
        return Client.post(`/system/membership/admin`,
            {
                email: email
            });
    },

    deleteAdmin(email) {
        return Client.delete(`/system/membership/admin`, {
            params: {
                email: email
            }
        });
    },

    //#endregion 
};
